export class Entity {
	constructor() {
		this.baseLevel = 0
		this.Hp = 0
		this.Sp = 0
		this.Defense = 0
		this.MagicDefense = 0
		this.skillList = []
		this.Str = 0
		this.Agi = 0
		this.Vit = 0
		this.Int = 0
		this.Dex = 0
		this.Luk = 0
		this.Size = 0
		this.Race = 0
		this.Element = 0
		this.ElementLevel = 0
		this.AttackRange = 0
	}
}

export class Player extends Entity {
	constructor(blv, jlv, skills, subStats, stats, bonuses, inventory) {
		super()

		this.baseLevel = blv
		this.jobLevel = jlv
		this.MaxHp = subStats.MaxHP
		this.MaxSp = subStats.MaxSP
		this.Defense = subStats.DEF
		this.SoftDefense = subStats.SoftDEF
		this.MagicDefense = subStats.MDEF
		this.SoftMagicDefense = subStats.SoftMDEF
		this.Hit = subStats.Hit
		this.Flee = subStats.Flee
		this.skillList = skills
		this.Str = stats.str
		this.Agi = stats.agi
		this.Vit = stats.vit
		this.Int = stats.int
		this.Dex = stats.dex
		this.Luk = stats.luk
		this.Bonuses = bonuses
		this.Inventory = inventory
		this.Class = 'Player'
	}
}

export class Monster extends Entity {
	constructor(monster) {
		super()

		this.baseLevel = defaultValue(monster?.Level, 1)
		this.Hp = defaultValue(monster?.Hp, 1)
		this.Sp = defaultValue(monster?.Sp, 0)
		this.Defense = defaultValue(monster?.Defense, 0)
		this.SoftDefense = Math.floor(
			(defaultValue(monster?.Vit, 0) + defaultValue(monster?.Level, 0)) /
				2,
		)

		this.MagicDefense = defaultValue(monster?.MagicDefense, 0)
		this.SoftMagicDefense =
			Math.floor(defaultValue(monster?.Level, 0) / 4) +
			Math.floor(defaultValue(monster?.Vit, 0) / 10) +
			Math.floor(defaultValue(monster?.Int, 0) / 5)
		this.skillList = []
		this.Str = defaultValue(monster?.Str, 0)
		this.Agi = defaultValue(monster?.Agi, 0)
		this.Vit = defaultValue(monster?.Vit, 0)
		this.Int = defaultValue(monster?.Int, 0)
		this.Dex = defaultValue(monster?.Dex, 0)
		this.Luk = defaultValue(monster?.Luk, 0)
		this.Size = defaultValue(monster?.Size, 'Small')
		this.Race = defaultValue(monster?.Race, 'Formless')
		this.Element = defaultValue(monster?.Element, 'Neutral')
		this.ElementLevel = defaultValue(monster?.ElementLevel, 1)
		this.AttackRange = defaultValue(monster?.AttackRange, 1)
		this.Class = defaultValue(monster?.Class, 'Normal')

		this.reqHit =
			200 +
			defaultValue(monster?.Level, 1) +
			defaultValue(monster?.Agi, 0)
		this.reqFlee =
			170 +
			defaultValue(monster?.Level, 1) +
			defaultValue(monster?.Dex, 0)
	}
}

export function defaultValue(variable, min) {
	return variable ? variable : min
}
